import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/authentication/authentication.service';
import { environment } from 'src/environments/environment';
import { LandingRedirectService } from 'src/app/shared/services/landing-redirect.service';
import { Router } from '@angular/router';
import { Constants } from '../constants';
import { BroadcastService } from '../services/broadcast.service';
import { IsauthorizedService } from '../services/isauthorized.service';
import { MatAccordion } from '@angular/material/expansion';
import { PermissionsEnum, RoutesPermissionsEnum } from 'src/app/core/enumerations/permissions-enum';
import { UserInfoService } from 'src/app/core/services/common/userInfo.service';

@Component({
    selector: 'app-responsive-navbar',
    templateUrl: './responsive-navbar.component.html',
    styleUrls: ['./responsive-navbar.component.scss'],
    standalone: false
})
export class ResponsiveNavbarComponent implements OnInit {
  @ViewChild(MatAccordion) accordion: MatAccordion;
  public userName = '';
  public userBU = '';
  cdnImageUrl: string;
  public hasPendingApprovalPermission: boolean;
  hasInputPocPermission: boolean;
  hasLinkedAccounts: boolean;
  hasCanPlaceOrdersPermission: boolean;
  isTgiBu: boolean;

  constructor(private authService: AuthenticationService,
              private landingService: LandingRedirectService,
              private router: Router,
              private broadcastService: BroadcastService,
              public isAuthorizedService: IsauthorizedService,
              private userInfo: UserInfoService) {
                this.userInfo.HasLinkedAccount().subscribe((data) => {
                  this.hasLinkedAccounts = data;
                });
                this.cdnImageUrl = environment.cdnImageServiceUrl;
  }

  ngOnInit() {
    this.broadcastService.subscribe().subscribe(message => {
      if (message.type === Constants.USERNAME_AT_TOOLBAR) {
        if (message.payload.middleInitial === '' || message.payload.middleInitial === ' ' || message.payload.middleInitial === null) {
          this.userName = message.payload.firstName + ' ' + message.payload.lastName;
        } else {
          this.userName = message.payload.firstName + ' ' + message.payload.middleInitial + ' ' + message.payload.lastName;
        }
      }
    });
    this.getUserPermissions();
    this.getInputPocPermission();
    this.getCanPlaceOrdersPermission();
    this.checkIfTgiBu();
  }
  orderCheck() {
    return this.hasLinkedAccounts;
  }

  getPageToRedirect() {
    this.router.navigate([Constants.HOME_TAB]);
  }
  getUserName() {
    if (this.userName !== '') {
      return this.userName;
    } else {
      const loginUserInfo = this.authService.GetLoggedInUserDetails();
      if (loginUserInfo !== null) {
        const middleName = loginUserInfo.middleName ? loginUserInfo.middleName.trim() : '';
        if (middleName === '' || middleName === null) {
          return loginUserInfo.firstName + ' ' + loginUserInfo.lastName;
        } else {
          return loginUserInfo.firstName + ' ' + loginUserInfo.middleName + ' ' + loginUserInfo.lastName;
        }
      }
    }
  }

  getUserPermissions() {
    const userPersmissions = this.authService.GetUserPermissions();
    if (userPersmissions.includes(PermissionsEnum.CanApproveOrders)) {
      this.hasPendingApprovalPermission = true;
    } else {
      this.hasPendingApprovalPermission = false;
    }
  }

  getInputPocPermission() {
    const userPersmissions = this.authService.GetUserPermissions();
    if (userPersmissions.includes(PermissionsEnum.CanInputPOCResults)) {
      this.hasInputPocPermission = true;
    } else {
      this.hasInputPocPermission = false;
    }
  }

  getCanPlaceOrdersPermission() {
    const userPermissions = this.authService.GetUserPermissions();
    this.hasCanPlaceOrdersPermission = userPermissions.includes(PermissionsEnum.CanPlaceOrders);
  }

  checkIfTgiBu() {
    const loggedInUserInfo = this.authService.GetLoggedInUserDetails();
    this.isTgiBu = loggedInUserInfo?.businessUnits?.some(x => x.buCode.includes(Constants.BUCODE_TGI)) ?? false;
  }

}
